declare global {
  interface BigInt {
    toJSON: () => string
  }
}

export default defineNuxtPlugin(() => {
  BigInt.prototype.toJSON = function () {
    return this.toString()
  }
})
